import { Box, Chip, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { BulkCreateMenuEntryPayload } from "src/data/admin/types/menu";
import { colorBorder, colorSurface, colorTextMuted } from "src/design/tokens";

interface Props {
    entries: BulkCreateMenuEntryPayload[];
}

const BulkMenuTable = ({ entries }: Props) => (
    <Paper
        variant="outlined"
        sx={{
            mt: 3,
            overflow: "auto",
            border: `1px solid ${colorBorder}`,
            backgroundColor: colorSurface,
        }}
    >
        <Box sx={{ px: 2, pt: 1.5, pb: 1, borderBottom: `1px solid ${colorBorder}` }}>
            <Typography variant="caption" color="text.secondary">
                Showing {entries.length} item{entries.length === 1 ? "" : "s"}
            </Typography>
        </Box>
        <Table size="small">
            <TableHead>
                <TableRow sx={{ "& th": { fontWeight: 600, color: colorTextMuted, fontSize: 12 } }}>
                    <TableCell>#</TableCell>
                    <TableCell>Section</TableCell>
                    <TableCell>Priority</TableCell>
                    <TableCell>Item</TableCell>
                    <TableCell>Price</TableCell>
                    <TableCell>Featured</TableCell>
                    <TableCell>Description</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {entries.map((entry, i) => (
                    <TableRow key={i} hover>
                        <TableCell sx={{ color: colorTextMuted, fontSize: 11 }}>{i + 1}</TableCell>
                        <TableCell>
                            <Chip label={entry.section} size="small" variant="outlined" sx={{ fontSize: 11 }} />
                        </TableCell>
                        <TableCell sx={{ color: colorTextMuted }}>{entry.priority}</TableCell>
                        <TableCell sx={{ fontWeight: 500 }}>{entry.item}</TableCell>
                        <TableCell>{entry.price.toFixed(2)} Dh</TableCell>
                        <TableCell>
                            <Chip
                                label={entry.featured ? "Yes" : "No"}
                                size="small"
                                color={entry.featured ? "success" : "default"}
                                variant="outlined"
                                sx={{ fontSize: 11 }}
                            />
                        </TableCell>
                        <TableCell sx={{ color: colorTextMuted, maxWidth: 300, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {entry.description || "—"}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </Paper>
);

export default BulkMenuTable;
